import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import partnerContactPersonAPI from '@infrastructure/partner-contact-person-api';
import { getPartnerByIdAsync } from '../partner/partnerThunk';
import { toast } from 'react-toastify';
import i18n from '@application/utilities/i18n';
export const createPartnerContactPersonAsync = createAsyncThunk('partnerContactPerson/create', async ({ partnerId, request }, { rejectWithValue, dispatch }) => {
    try {
        await partnerContactPersonAPI.createPartnerContactPerson(partnerId, request);
        toast.success(i18n.t('sponsorships.contactPersonCreatedSuccessfully'));
        // Refresh partner details to reflect contacts
        await dispatch(getPartnerByIdAsync(partnerId));
    }
    catch (error) {
        toast.error(i18n.t('sponsorships.failedToCreateContactPerson'));
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updatePartnerContactPersonAsync = createAsyncThunk('partnerContactPerson/update', async ({ partnerId, request }, { rejectWithValue, dispatch }) => {
    try {
        await partnerContactPersonAPI.updatePartnerContactPerson(partnerId, request);
        toast.success(i18n.t('sponsorships.contactPersonUpdatedSuccessfully'));
        await dispatch(getPartnerByIdAsync(partnerId));
    }
    catch (error) {
        toast.error(i18n.t('sponsorships.failedToUpdateContactPerson'));
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deletePartnerContactPersonAsync = createAsyncThunk('partnerContactPerson/delete', async ({ partnerId, contactPersonId }, { rejectWithValue, dispatch }) => {
    try {
        await partnerContactPersonAPI.deletePartnerContactPerson(contactPersonId);
        toast.success(i18n.t('sponsorships.contactPersonDeletedSuccessfully'));
        await dispatch(getPartnerByIdAsync(partnerId));
    }
    catch (error) {
        toast.error(i18n.t('sponsorships.failedToDeleteContactPerson'));
        return rejectWithValue(getErrorPayload(error));
    }
});
